import React from "react";
import NoQuiz from "../../assets/images/noQuiz.png";

interface EmptyStateProps {
  title?: string;
  message: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, message }) => {
  return (
    <div className="flex flex-col items-center justify-center py-14 px-5 text-[#64748B] text-center bg-[#FFFFFF] rounded-xl border border-dashed border-[#E2E8F0] mt-6 w-full">
      <img src={NoQuiz} alt="No Quiz" className="mb-5 opacity-60 w-[100px] h-auto" />
      <h3 className="text-xl mb-2 text-[#1F2937]">{title || "No Quizzes Available"}</h3>
      <p className="text-[15px] max-w-[400px]">{message}</p>
    </div>
  );
};

export default EmptyState;
